/**
 * Utility to dynamically change the favicon
 */
export class FaviconUtil {
  private static defaultFavicon = 'favicon.ico';

  private static geochatFavicon = 'geochat-favicon.ico';

  /**
   * Changes the favicon to the geochat icon
   */
  static setGeoChatFavicon(): void {
    this.changeFavicon(this.geochatFavicon);
  }

  /**
   * Restores the default favicon
   */
  static setDefaultFavicon(): void {
    this.changeFavicon(this.defaultFavicon);
  }

  /**
   * Changes the favicon in the document head
   * @param faviconPath - Path to the favicon file
   */
  private static changeFavicon(faviconPath: string): void {
    const link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");

    if (link) {
      link.href = `${process.env.BASE_URL}${faviconPath}`;
    } else {
      // If no favicon link exists, create one
      const newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.href = `${process.env.BASE_URL}${faviconPath}`;
      document.head.appendChild(newLink);
    }
  }
}
